// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_z-2";
export var blackBorderOnHover = "_z-7";
export var cell = "_z-6";
export var cellContainer = "_z-3";
export var checked = "_z-8";
export var disabled = "_z-5";
export var featuredIconCellContainer = "_z-9";
export var featuredIconTextContainer = "_z-b";
export var featuredIconWrapper = "_z-a";
export var noBorder = "_z-c";
export var orangeSelectedRow = "_3f-3";
export var overflowableText = "_z-0";
export var overflowableTextContainer = "_z-1";
export var row = "_10-0";
export var rowCheckboxCell = "_z-4";
export var selectableTable = "_3f-2";